export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const CLEAR_SELECTED_USER = 'CLEAR_SELECTED_USER';
export class SetSelectedUser {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_SELECTED_USER;
    }
}
export class ClearSelectedUser {
    constructor() {
        this.type = CLEAR_SELECTED_USER;
    }
}
export const setSelectedUser = (user) => (dispatch) => {
    dispatch(new SetSelectedUser(user));
};
export const clearSelectedUser = () => (dispatch) => {
    dispatch(new ClearSelectedUser());
};
